import { IWT_THEME } from "@gemini/tokens";
import { getCookieDomain } from "@aviv-unified-frontend/internal";

import { useGoogleOneTap } from "../../../src/components/OverlayOrchestrator/overlays/GoogleOneTap/useGoogleOneTap";
import {
  ENVIRONMENT,
  STAGE_LIKE_ENVIRONMENT,
  VERSION_EPHEMERAL,
} from "../../../src/constants/environment";
import { createB2CBrand } from "../createB2CBrand";

import { customBannerConfig } from "./customBannerConfig";

const origin = {
  dev: "https://dev.immowelt.de",
  preview: "https://preview.immowelt.de",
  live: "https://www.immowelt.de",
};

const consentID = {
  dev: "tgGfX8jGOFRVIz",
  preview: "dWLDa0s-m",
  live: "dWLDa0s-m",
};

const airshipConfig = {
  dev: {
    appKey: "lQ93SvosSh2EY65ZojUN3g",
    token:
      "MTpsUTkzU3Zvc1NoMkVZNjVab2pVTjNnOk9kZTZSRGFFVHAzMFJSUmZqd2RsWWpFWXg0dnpBSFhUTVFSNVRHd3U0YnM",
    vapidPublicKey:
      "BO2zJijXTVk9eCV2gXpt01XVqB2Trdt6B4W35SBjJOI7bnNhaggpZjjwCFBNypQDCWezp0lJw-jQRyJg2Hgab64=",
  },
  preview: {
    appKey: "lQ93SvosSh2EY65ZojUN3g",
    token:
      "MTpsUTkzU3Zvc1NoMkVZNjVab2pVTjNnOk9kZTZSRGFFVHAzMFJSUmZqd2RsWWpFWXg0dnpBSFhUTVFSNVRHd3U0YnM",
    vapidPublicKey:
      "BO2zJijXTVk9eCV2gXpt01XVqB2Trdt6B4W35SBjJOI7bnNhaggpZjjwCFBNypQDCWezp0lJw-jQRyJg2Hgab64=",
  },
  live: {
    appKey: "CQXdr0B9RhylF3_SZVGKSw",
    token:
      "MTpDUVhkcjBCOVJoeWxGM19TWlZHS1N3Onl6cTFOSmE5dzdxaWY4SlhzUXN4SVZkdWZWOTM5ZVdPbmJtM1VBRUIzWGs",
    vapidPublicKey:
      "BBpZz3rPT_-5VRfpRsfEakQfedixUFermMXF21wx9ecLX8VTYzospBYnXySmHpDPDUB20KWbv25izPes-gvMqy0=",
  },
};

const brandName = "Immowelt";

const authenticationConfig = {
  dev: {
    cookies: {
      accessToken: "oauth.access.token",
      sessionExpiration: "oauth.access.se",
    },
    urls: {
      refresh: "https://dev-signin.immowelt.de/refresh",
      signIn: "https://dev-signin.immowelt.de/?redirect_uri=",
    },
    googleOneTap: {
      googleClientId:
        "1023568262733-r92lsr931ull589h6ddt3ob5rv1anpln.apps.googleusercontent.com",
      auth0: {
        clientId: "G3omOoCj8KGMSfyM8SSdQlwVme5lYoF2",
        audience: brandName,
      },
      useGoogleOneTap,
    },
  },
  preview: {
    cookies: {
      accessToken: "oauth.access.token",
      sessionExpiration: "oauth.access.se",
    },
    urls: {
      refresh: "https://preview-signin.immowelt.de/refresh",
      signIn: "https://preview-signin.immowelt.de/?redirect_uri=",
    },
    googleOneTap: {
      googleClientId:
        "1023568262733-r92lsr931ull589h6ddt3ob5rv1anpln.apps.googleusercontent.com",
      auth0: {
        clientId: "IK8eGFqHmrkTTFPOgl6t05NxHTYamgbg",
        audience: brandName,
      },
      useGoogleOneTap,
    },
  },
  live: {
    cookies: {
      accessToken: "oauth.access.token",
      sessionExpiration: "oauth.access.se",
    },
    urls: {
      refresh: "https://signin.immowelt.de/refresh",
      signIn: "https://signin.immowelt.de/?redirect_uri=",
    },
    googleOneTap: {
      googleClientId:
        "358936558207-jrc2puscu72918c4ig0p9tmbj1q61k6v.apps.googleusercontent.com",
      auth0: {
        clientId: "NtzNjnW22Ynce1vkuATtEM1oTQ3A9ueA",
        audience: brandName,
      },
      useGoogleOneTap,
    },
  },
};

export default createB2CBrand({
  id: "iwt",
  name: brandName,
  defaultTitle: brandName,
  defaultDescription: brandName,
  theme: IWT_THEME,
  i18n: {
    supportedLanguageTags: ["de-DE"],
    defaultLanguageTag: "de-DE",
  },
  portal: "immowelt.de",
  origin: origin[STAGE_LIKE_ENVIRONMENT],
  appBanner: {
    adjust: {
      android: "amh4kvapbcyc",
      ios: "e8r3raneanqg",
    },
    custom: customBannerConfig,
  },
  consentManagement: {
    id: consentID[STAGE_LIKE_ENVIRONMENT],
  },
  qualtrics: {
    id: "ZN_2ckDltrd5peAJGt",
    id_url: "QSI_S_ZN_2ckDltrd5peAJGt",
    url: "https://zn2ckdltrd5peajgt-avivgroup.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_2ckDltrd5peAJGt",
  },
  airship: {
    ...airshipConfig[STAGE_LIKE_ENVIRONMENT],
    trackingConsentId: "b7qUNUGPaAEgAz",
    pushConsentId: "yQNb4U0iFb2Cbz",
  },
  featureFlagging: {
    domain: getCookieDomain(
      origin,
      ENVIRONMENT,
      `immowelt-${VERSION_EPHEMERAL}-b2c-shell.unified-lion-dev.aws.aviv.eu`,
      VERSION_EPHEMERAL,
    ),
    siteCode: "lrj80dsya2",
  },
  authentication: authenticationConfig[STAGE_LIKE_ENVIRONMENT],
  errorEmailAddress: "support@immowelt.de",
});
